// Mock data for Noctavian Studio website

export const collaborativeProjects = [
  {
    id: 1,
    title: "Dungeon Match",
    titleTr: "Dungeon Match",
    description: "Dungeon Match is a competitive, turn-based puzzle combat game built for mobile. Players face each other in tactical duels where match-based moves directly translate into attacks, defense, and resource management.",
    descriptionTr: "Dungeon Match, mobil platformlar için geliştirilen, rekabetçi ve sıra tabanlı bir puzzle savaş oyunudur. Oyuncular, eşleştirme hamlelerinin doğrudan saldırı, savunma ve kaynak yönetimine dönüştüğü taktiksel düellolarda karşı karşıya gelir.",
    category: "mobile",
    tag: "Mobile Game",
    tagTr: "Mobil Oyun",
    status: "coming-soon",
    image: "https://customer-assets.emergentagent.com/job_design-clone-55/artifacts/22pcfsao_DUNGEON%20MATCH.png",
    gameUrl: null
  },
  {
    id: 2,
    title: "Storm Warfare",
    titleTr: "Storm Warfare",
    description: "Storm Warfare is a turn-based digital card game built for PC, centered around tactical decision-making and controlled battlefield momentum. Players construct decks, deploy units, and trigger abilities to outmaneuver their opponent across structured combat encounters.",
    descriptionTr: "Storm Warfare, PC platformu için geliştirilen, sıra tabanlı ve taktik odaklı bir dijital kart oyunudur. Oyuncular, destelerini oluşturur, birimlerini sahaya sürer ve yetenekleri doğru zamanda kullanarak rakiplerini alt etmeye çalışır.",
    category: "pc",
    tag: "PC Game",
    tagTr: "PC Oyunu",
    status: "active",
    image: "https://customer-assets.emergentagent.com/job_design-clone-55/artifacts/j1j2gb8q_STORM%20WARFARE.png",
    gameUrl: "https://stormwarfare.com"
  }
];

export const games = [
  {
    id: 1,
    title: "Ecopak X",
    titleTr: "Ecopak X",
    description: "An industrial simulation game centered on controlling a solar panel cleaning robot. Players manage efficiency, movement, and environmental challenges to maximize cleaning performance. Developed for educational and promotional purposes.",
    descriptionTr: "Güneş paneli temizleme robotunu kontrol etmeye odaklanan endüstriyel simülasyon oyunu. Oyuncular verimlilik, hareket ve çevresel zorlukları yöneterek temizlik performansını maksimize eder. Eğitim ve tanıtım amaçlı geliştirilmiştir.",
    category: "mobile",
    tag: "Mobile Game",
    tagTr: "Mobil Oyun",
    status: "coming-soon",
    image: "https://customer-assets.emergentagent.com/job_design-clone-55/artifacts/q0ghaouq_ECOPAK%20X.png",
    gameUrl: null
  },
  {
    id: 2,
    title: "Blitz Brigade",
    titleTr: "Blitz Brigade",
    description: "A cooperative board game set in World War II London. Players take on the role of a firefighting brigade responding to air raids, managing crises through teamwork, tactical planning, and resource coordination.",
    descriptionTr: "İkinci Dünya Savaşı Londra'sında geçen kooperatif masa oyunu. Oyuncular hava saldırılarına müdahale eden itfaiye tugayı rolünü üstlenir, takım çalışması, taktik planlama ve kaynak koordinasyonu ile krizleri yönetir.",
    category: "board",
    tag: "Board Game",
    tagTr: "Masa Oyunu",
    status: "coming-soon",
    image: "https://customer-assets.emergentagent.com/job_design-clone-55/artifacts/j68irtq1_BLITZ%20BRIGADE.png",
    gameUrl: null
  },
  {
    id: 3,
    title: "Gooooal!!!",
    titleTr: "Gooooal!!!",
    description: "A two-player football-themed board game combining dice rolls, card mechanics, and positional strategy. Fast matches, tactical decisions, and head-to-head competition drive the experience.",
    descriptionTr: "Zar atışları, kart mekanikleri ve pozisyon stratejisini birleştiren iki kişilik futbol temalı masa oyunu. Hızlı maçlar, taktik kararlar ve kafa kafaya rekabet deneyimi sunar.",
    category: "board",
    tag: "Board Game",
    tagTr: "Masa Oyunu",
    status: "active",
    image: "https://customer-assets.emergentagent.com/job_design-clone-55/artifacts/qa1bnd86_GOOOOAL.png",
    gameUrl: "https://boardgamegeek.com/boardgame/434510/gooooal"
  },
  {
    id: 4,
    title: "Axis All Together",
    titleTr: "Axis All Together",
    description: "A cooperative World War II aerial combat PC game where players work together as a squadron. Coordinate attacks, manage resources, and complete missions through strategic teamwork.",
    descriptionTr: "Oyuncuların bir filo olarak birlikte çalıştığı kooperatif İkinci Dünya Savaşı hava muharebesi PC oyunu. Saldırıları koordine edin, kaynakları yönetin ve stratejik takım çalışmasıyla görevleri tamamlayın.",
    category: "pc",
    tag: "PC Game",
    tagTr: "PC Oyunu",
    status: "coming-soon",
    image: "https://customer-assets.emergentagent.com/job_design-clone-55/artifacts/hemtqxzp_AXIS%20ALL%20TOGETHER.png",
    gameUrl: null
  },
  {
    id: 5,
    title: "Axis Alone",
    titleTr: "Axis Alone",
    description: "A solo variant World War II flight simulation PC game. Take control of a single pilot, manage your aircraft, and survive intense aerial combat scenarios on your own.",
    descriptionTr: "Solo oynanabilen İkinci Dünya Savaşı uçuş simülasyonu PC oyunu. Tek bir pilotu kontrol edin, uçağınızı yönetin ve yoğun hava muharebesi senaryolarında hayatta kalın.",
    category: "pc",
    tag: "PC Game",
    tagTr: "PC Oyunu",
    status: "coming-soon",
    image: "https://customer-assets.emergentagent.com/job_design-clone-55/artifacts/v1kop8n5_AXIS%20ALONE.png",
    gameUrl: null
  },
  {
    id: 6,
    title: "Museum of Curses",
    titleTr: "Museum of Curses",
    description: "A dark, gothic-themed slot game concept built around cursed artifacts and occult symbolism. Strong visual identity and atmospheric worldbuilding define its tone and presentation.",
    descriptionTr: "Lanetli eserler ve okült sembolizm etrafında inşa edilmiş karanlık, gotik temalı slot oyunu konsepti. Güçlü görsel kimlik ve atmosferik dünya inşası tonunu ve sunumunu tanımlar.",
    category: "chance",
    tag: "Game of Chance",
    tagTr: "Şans Oyunu",
    status: "coming-soon",
    image: "https://customer-assets.emergentagent.com/job_design-clone-55/artifacts/6bl3w29o_MUSEUM%20of%20CURSES.png",
    gameUrl: null
  },
  {
    id: 7,
    title: "Harf It",
    titleTr: "Harf It",
    description: "A fun and educational word puzzle mobile game that challenges players to form words from given letters. Perfect for all ages to improve vocabulary and have fun.",
    descriptionTr: "Oyuncuları verilen harflerden kelime oluşturmaya davet eden eğlenceli ve eğitici bir kelime bulmaca mobil oyunu. Kelime dağarcığını geliştirmek ve eğlenmek için her yaşa uygun.",
    category: "mobile",
    tag: "Mobile Game",
    tagTr: "Mobil Oyun",
    status: "coming-soon",
    image: "https://customer-assets.emergentagent.com/job_design-clone-55/artifacts/ziaiuzta_Harf%20It.png",
    gameUrl: null
  },
  {
    id: 8,
    title: "U-Diver",
    titleTr: "U-Diver",
    description: "An underwater adventure mobile game where players explore the depths of the ocean, discover treasures, and encounter marine life. Dive deep and uncover the mysteries of the sea.",
    descriptionTr: "Oyuncuların okyanusun derinliklerini keşfettiği, hazineler bulduğu ve deniz yaşamıyla karşılaştığı su altı macera mobil oyunu. Derinlere dalın ve denizin gizemlerini ortaya çıkarın.",
    category: "mobile",
    tag: "Mobile Game",
    tagTr: "Mobil Oyun",
    status: "coming-soon",
    image: "https://customer-assets.emergentagent.com/job_design-clone-55/artifacts/aqa3g1vt_U-Diver.png",
    gameUrl: null
  },
  {
    id: 9,
    title: "Makara",
    titleTr: "Makara",
    description: "Makara is a fast-paced word game where players create new words using the last letter of the previous one. Designed to test vocabulary, speed, and creativity, the game encourages quick thinking and clever word choices. Easy to learn and highly competitive, Makara keeps every round lively and engaging.",
    descriptionTr: "Makara, bir önceki kelimenin son harfiyle yeni kelimeler üretmeye dayalı, hızlı tempolu bir kelime oyunudur. Kelime bilgisi, hız ve yaratıcılığı ön plana çıkarır. Kolay öğrenilen kuralları ve rekabetçi yapısıyla her turu dinamik kılar.",
    category: "board",
    tag: "Board Game",
    tagTr: "Masa Oyunu",
    status: "active",
    image: "https://customer-assets.emergentagent.com/job_design-clone-55/artifacts/ukm0t8bf_MAKARA.png",
    gameUrl: "https://boardgamegeek.com/boardgame/411980/makara"
  },
  {
    id: 10,
    title: "Makara 90'lar",
    titleTr: "Makara 90'lar",
    description: "Makara 90'lar is a nostalgic variation of the original Makara game, inspired by 1990s pop culture. By introducing era-themed words and references, it adds a playful and memory-driven layer to the classic word-chaining mechanics, blending humor with language skills.",
    descriptionTr: "Makara 90'lar, orijinal Makara oyununun 1990'lar pop kültüründen ilham alan nostaljik bir versiyonudur. Döneme özgü kelimeler ve göndermelerle, klasik kelime zinciri mekaniğine eğlenceli ve hatıra odaklı bir katman ekler.",
    category: "board",
    tag: "Board Game",
    tagTr: "Masa Oyunu",
    status: "active",
    image: "https://customer-assets.emergentagent.com/job_design-clone-55/artifacts/vhwcn7v4_MAKARA%2090.png",
    gameUrl: "https://boardgamegeek.com/boardgame/438687/makara-90lar"
  },
  {
    id: 11,
    title: "Wombat Kombat",
    titleTr: "Wombat Kombat",
    description: "Wombat Kombat is a lighthearted, family-friendly board game where animal characters clash in chaotic and humorous battles. With fast turns and simple mechanics, the game focuses on playful competition, accessibility, and strong visual appeal.",
    descriptionTr: "Wombat Kombat, hayvan karakterlerin kaotik ve eğlenceli mücadelelere girdiği, aile dostu bir masaüstü oyunudur. Basit mekanikleri, hızlı turları ve güçlü görsel diliyle eğlenceyi ön plana çıkarır.",
    category: "board",
    tag: "Board Game",
    tagTr: "Masa Oyunu",
    status: "active",
    image: "https://customer-assets.emergentagent.com/job_design-clone-55/artifacts/clopngs6_WOMBAT%20KOMBAT.png",
    gameUrl: "https://boardgamegeek.com/boardgame/339754/wombat-kombat"
  },
  {
    id: 12,
    title: "Lycka Bingo",
    titleTr: "Lycka Bingo",
    description: "Bingo is a classic game of chance where players mark numbers on their cards as they are randomly drawn. The goal is to complete specific number patterns before other players. Simple rules, anticipation, and social interaction are at the heart of the experience.",
    descriptionTr: "Bingo, rastgele çekilen sayıları kart üzerinde işaretlemeye dayalı klasik bir şans oyunudur. Amaç, belirli sayı desenlerini diğer oyunculardan önce tamamlamaktır. Basit kuralları, heyecan duygusu ve sosyal yapısıyla öne çıkar.",
    category: "chance",
    tag: "Game of Chance",
    tagTr: "Şans Oyunu",
    status: "coming-soon",
    image: "https://customer-assets.emergentagent.com/job_design-clone-55/artifacts/0sm30hsj_BINGO.png",
    gameUrl: null
  }
];

export const categories = [
  { id: "all", label: "All Categories", labelTr: "Tüm Kategoriler" },
  { id: "mobile", label: "Mobile Game", labelTr: "Mobil Oyun" },
  { id: "board", label: "Board Game", labelTr: "Masa Oyunu" },
  { id: "pc", label: "PC Game", labelTr: "PC Oyunu" },
  { id: "chance", label: "Game of Chance", labelTr: "Şans Oyunu" }
];

export const tagColors = {
  "Mobile Game": { bg: "bg-cyan-600", text: "text-white", border: "border-cyan-500" },
  "Board Game": { bg: "bg-orange-600", text: "text-white", border: "border-orange-500" },
  "PC Game": { bg: "bg-emerald-600", text: "text-white", border: "border-emerald-500" },
  "Game of Chance": { bg: "bg-purple-600", text: "text-white", border: "border-purple-500" }
};

export const services = [
  {
    id: 1,
    title: "Tailored Game Creation",
    titleTr: "Özel Oyun Üretimi",
    description: "Every project is built from the ground up, shaped around your specific goals, ideas, and needs.",
    descriptionTr: "Her proje, hedeflerinize ve fikirlerinize özel olarak sıfırdan inşa edilir.",
    icon: "Gamepad2"
  },
  {
    id: 2,
    title: "Flexible Across Genres and Styles",
    titleTr: "Tür ve Stil Esnekliği",
    description: "From physical board games to mobile and digital titles, we adapt to any genre, mechanic, or visual language.",
    descriptionTr: "Masaüstü oyunlardan mobil ve dijital projelere kadar, her tür ve görsel dile uyum sağlıyoruz.",
    icon: "Palette"
  },
  {
    id: 3,
    title: "Built with Precision and Polish",
    titleTr: "Hassasiyet ve Özenle Üretilmiş",
    description: "We focus on clarity, balance, and polish to deliver results that meet professional production standards.",
    descriptionTr: "Profesyonel üretim standartlarını karşılayan, dengeli ve rafine sonuçlara odaklanıyoruz.",
    icon: "Award"
  },
  {
    id: 4,
    title: "Working Side by Side",
    titleTr: "Birlikte Üreterek İlerlemek",
    description: "We stay in close communication throughout development, ensuring every step aligns with your original vision.",
    descriptionTr: "Geliştirme süreci boyunca sizinle yakın çalışarak her aşamanın vizyonunuzla örtüşmesini sağlıyoruz.",
    icon: "Users"
  }
];

export const contactInfo = {
  email: "info@noctavian.com",
  phone: "+90 543 285 57 02",
  address: "Yeni Mh. 500. Sk No:11 16940 Mudanya/BURSA",
  addressTr: "Yeni Mh. 500. Sk No:11 16940 Mudanya/BURSA",
  social: {
    instagram: "https://www.instagram.com/noctavian.studio/",
    twitter: "https://x.com/noctavian_stud",
    linkedin: "https://www.linkedin.com/company/noctavian-studio/"
  }
};

export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      games: "Games",
      collaborative: "Collab Projects",
      contact: "Contact"
    },
    hero: {
      tagline: "Thoughtful, Bold, and Player-Driven Experiences",
      title: "Crafting games in the silence of night",
      subtitle: "Welcome to Noctavian Studio. We transform game ideas into engaging, well-crafted experiences across mobile, tabletop, and digital platforms.",
      cta: "Our Games"
    },
    games: {
      sectionTag: "Play something new. Find the experience that stays with you.",
      title: "Enter the Games",
      subtitle: "Explore a diverse collection of games crafted for different play styles. Whether you enjoy careful strategy or pure momentum, there's always a new experience waiting.",
      comingSoon: "Coming Soon",
      tryDemo: "Try Demo",
      goToGame: "Go to Game"
    },
    collaborative: {
      sectionTag: "Collaborative Projects",
      title: "Collaborative Projects",
      subtitle: "These projects represent games where Noctavian Studio contributed as part of a broader team. Our involvement varied across design, art direction, illustration, and development support, depending on each project's scope."
    },
    about: {
      sectionTag: "Let's build the game you've been imagining.",
      title: "We guide your idea from the first concept to a finished, playable experience.",
      subtitle: "Share your vision with us, and we'll shape it into a fully realized game, built with care, precision, and a clear creative direction."
    },
    contact: {
      sectionTag: "Get In Touch",
      title: "Contact Us",
      subtitle: "Have an idea you'd like to explore? Let's talk and turn it into something playable.",
      form: {
        name: "Your Name",
        email: "Your Email",
        message: "Your Message",
        send: "Send Message"
      }
    },
    footer: {
      copyright: "© 2025 Noctavian Studio. All rights reserved.",
      tagline: "Crafting games in the silence of night."
    }
  },
  tr: {
    nav: {
      home: "Ana Sayfa",
      about: "Hakkımızda",
      games: "Oyunlar",
      collaborative: "Ortak Projeler",
      contact: "Contact"
    },
    hero: {
      tagline: "Düşünülmüş, cesur ve oyuncu odaklı deneyimler",
      title: "Gecenin sessizliğinde oyunlar yaratıyoruz",
      subtitle: "Noctavian Studio'ya hoş geldiniz. Oyun fikirlerini mobil, masaüstü ve dijital platformlarda etkileyici ve özenle tasarlanmış deneyimlere dönüştürüyoruz.",
      cta: "Oyunlarımız"
    },
    games: {
      sectionTag: "Yeni bir şey oyna. Sende iz bırakan deneyimi keşfet.",
      title: "Oyunları Keşfet",
      subtitle: "Farklı oyun tarzları için tasarlanmış geniş bir oyun yelpazesini keşfet. İster stratejik düşünmeyi ister saf aksiyonu sev, seni bekleyen yeni bir deneyim mutlaka vardır.",
      comingSoon: "Çok Yakında",
      tryDemo: "Demo Dene",
      goToGame: "Oyuna Git"
    },
    collaborative: {
      sectionTag: "Katkı Sağlanan Projeler",
      title: "Katkı Sağlanan Projeler",
      subtitle: "Bu projeler, Noctavian Studio'nun daha geniş ekiplerin parçası olarak katkı sunduğu oyunları temsil eder. Katkı alanlarımız, her projenin kapsamına göre tasarım, sanat yönetimi, illüstrasyon ve geliştirme desteği gibi farklı disiplinleri içermektedir."
    },
    about: {
      sectionTag: "Aklındaki oyunu birlikte hayata geçirelim.",
      title: "Fikrinizi ilk konseptten oynanabilir son ürüne kadar birlikte şekillendiriyoruz.",
      subtitle: "Vizyonunuzu bizimle paylaşın; onu özenle, net bir yaratıcı yönle ve yüksek kaliteyle hayata geçirelim."
    },
    contact: {
      sectionTag: "İletişime Geçin",
      title: "Bize Ulaşın",
      subtitle: "Aklında bir proje mi var? Gelin konuşalım ve onu oynanabilir bir deneyime dönüştürelim.",
      form: {
        name: "Adınız",
        email: "E-posta Adresiniz",
        message: "Mesajınız",
        send: "Mesaj Gönder"
      }
    },
    footer: {
      copyright: "© 2025 Noctavian Studio. Tüm hakları saklıdır.",
      tagline: "Gecenin sessizliğinde oyunlar yaratıyoruz."
    }
  }
};
